import "../JSONTools/JSONformatter.css";
import "./formattools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { MarkdowntoHTMLAPI } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { markDownExapmple } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { ReactComponent as EyeIcon } from "../../Icons/eye.svg";
import { ReactComponent as CodeIcon } from "../../Icons/code.svg";
import { ReactComponent as CaretDownIcon } from "../../Icons/CaretDown.svg"

function HTMLFormatter() {
  const [text, setText] = useState("");
  const [reqBody, setReqBody] = useState();
  const [htmlResult, setHtmlResult] = useState("")
  const [mode, setMode] = useState("code");

  const toolFav = { toolName: 'Markdown to HTML', Iconpath: "/FileCodeRaw.svg" };
  const [, setIsValid] = useState(true);
  const [template, setTemplate] = useState(
    "<!DOCTYPE html><html><body>{CONTENT}</body></html>"
  );

  

  


  const lineCount = text !== "" ? (text || "").split("\n").length : 0;
  const resultLineCount = htmlResult !== "" ? (htmlResult ?? "").toString().split("\n").length : 0;

  const handleChange = (e) => {
    setText(e.target.value);
    setReqBody({
      markdown: e.target.value
    });
  };


  const converttoHTML = async () => {
    try {
      const response = await MarkdowntoHTMLAPI(reqBody);
      setHtmlResult(response.data.html);
      setIsValid(true);
    } catch (error) {
      if (error.response?.status === 400) {
        const apiMessage =
          error.response?.data?.message;
        setHtmlResult(apiMessage);
        setIsValid(false);
      } else {
        setHtmlResult("Something went wrong. Please try again.");
        setIsValid(false);
      }
    }
  };


  const pasteExample = () => {

    setText(markDownExapmple);
    setReqBody({
      markdown: markDownExapmple
    });
  }



  const handleImport = (filecontent) => {
    setText(filecontent);
    setReqBody({
      markdown: filecontent
    });
  };

  const previewDocument = template.includes("{CONTENT}")
    ? template.replace("{CONTENT}", htmlResult ?? "")
    : htmlResult ?? "";

  return (
    <>
      <Col>
        <ToolHeader title="Markdown to HTML" description="Convert markdown into clean, semantic HTML in real time" toolFav={toolFav} />

        <Row >
          <Col>
            <div className="custom-template-container">
              {/* Header */}
              <div className="template-header">
                <div className="template-title">
                  <CaretDownIcon className="dropdown-icon" />

                  <span>
                    Custom HTML Template (use{" "}
                    <span className="content-highlight">
                      {"{CONTENT}"}
                    </span>{" "}
                    for HTML output)
                  </span>
                </div>
              </div>

              {/* Code Input Box */}
              <div className="template-editor-wrapper">
                <textarea
                  className="template-editor"
                  value={template}
                  onChange={(e) => setTemplate(e.target.value)}
                />
              </div>

              {/* Footer text */}
              <div className="template-footer">
                Enable the "Template" toggle above to apply this wrapper.
              </div>
            </div>
          </Col>
        </Row>

        <Row className='Formatter json-formatter-row'>
          <Col xs={12} lg={6} className="json-formatter-column">
            <FormatterPanel
              title="Input"
              value={text}
              onChange={(e) => handleChange(e)}
              placeholder="Type your markdown here..."
              lineCount={lineCount}
              headerButtons={
                <InputHeaderButtons
                  primaryLabel="Example"
                  onPrimary={pasteExample}
                  onClear={() => {
                    setText("");
                    setReqBody("");
                    setHtmlResult("");
                  }}
                  onImport={(fileContent) => handleImport(fileContent)}
                  accept=".txt"
                  executeLabel={"Convert"}
                  showExecute={true}
                  onExecute={converttoHTML}
                />
              }
              footerLeft={`Characters : ${String(text ?? "").replaceAll(" ", "").length}`}
              footerRight={`Size : ${new Blob([text ?? ""]).size} B`}
            />
          </Col>
          <Col xs={12} lg={6} className="json-formatter-column">
            <FormatterPanel
              title="Formatted HTML"
              value={htmlResult ?? ""}
              placeholder={mode==="code" ? "Formatted HTML will appear here..." : ""}
              lineCount={resultLineCount}
              readOnly
              customContent={
                mode === "preview" ? (
                  <iframe
                    title="HTML Preview"
                    className="html-preview-frame"
                    srcDoc={previewDocument}
                    sandbox="allow-same-origin"
                  />
                ) : null
              }
              headerButtons={
                <OutputHeaderButtons
                  outputText={htmlResult ?? ""}
                  fileName="formatted.html"
                  mimeType="application/json;charset=utf-8"
                  extraButton={
                    <div className="html-toggle-container">
                      <div
                        className={`html-toggle-btn ${mode === "code" ? "active" : ""}`}
                        onClick={() => setMode("code")}>
                        < CodeIcon className="headerIcon toggleicon" /> &nbsp;
                        code
                      </div>
                      <div
                        className={`html-toggle-btn ${mode === "preview" ? "active" : ""}`}
                        onClick={() => setMode("preview")}> 
                        <EyeIcon className="headerIcon toggleicon" />&nbsp;
                        Preview
                      </div>
                    </div>
                  }
                />
              }
              footerLeft={`Characters : ${String(htmlResult ?? "").replaceAll(" ", "").length}`}
              footerRight={`Size : ${new Blob([htmlResult ?? ""]).size} B`}
            />
          </Col>
        </Row>
      </Col >
    </>
  )
}

export default HTMLFormatter;
